import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import { UserOperation } from '../../../../core/enums/user-operation';
import { ShiveDialogService } from '../../../../core/services/controls/shive-dialog.service';
import { FormControlNameRecord } from '../../../../shared/data-types/form-types';

@Component({
  selector: 'app-invitation-dialog',
  templateUrl: './invitation-dialog.component.html',
  standalone: false,
})
export class InvitationDialogComponent implements OnInit {
  public invitationForm: FormGroup;

  public readonly formControlNames: FormControlNameRecord = {
    Email: 'email',
  };

  // Misc
  public readonly faCirclePlus = faCirclePlus;

  // DI
  private readonly shiveDialogService = inject(ShiveDialogService);
  private readonly formBuilder = inject(FormBuilder);

  ngOnInit(): void {
    this.invitationForm = this.formBuilder.group({
      [this.formControlNames.Email]: ['', Validators.required],
    });
  }

  public invite(): void {
    const email = this.invitationForm.value.email;
    this.shiveDialogService.close(email);
  }

  public close(): void {
    this.shiveDialogService.close(UserOperation.Cancel);
  }
}
